import type { TermedLevel } from '../../common/termedLevel/types';
import { isManNowProduct, isManNowSubscriptionProduct, MAN_NOW_PARENT_PRODUCT_ID } from '../../config/manNowProducts';

type ContractDocuments = Pick<TermedLevel, 'productId' | 'tosVersion' | 'dosVersion'>;

export function resolveContractDocuments(contract: ContractDocuments) {
    // MAN Now subscriptions do not persist document versions and always link to the latest documents.
    if (isManNowSubscriptionProduct(contract.productId)) {
        return {
            productId: contract.productId,
            tosVersion: undefined,
            dosVersion: undefined,
            canOpenTos: true,
            canOpenDos: true,
        };
    }

    const tosVersion = contract.tosVersion?.trim() || undefined;
    const dosVersion = contract.dosVersion?.trim() || undefined;
    const usesManNowDocumentFallback = !tosVersion && !dosVersion && isManNowProduct(contract.productId);

    return {
        productId: usesManNowDocumentFallback ? MAN_NOW_PARENT_PRODUCT_ID : contract.productId,
        tosVersion,
        dosVersion,
        canOpenTos: usesManNowDocumentFallback || Boolean(tosVersion),
        canOpenDos: usesManNowDocumentFallback || Boolean(dosVersion),
    };
}
